<template>
  <div :class="$style.breadcrumbs">
    <div :class="$style.path">
      <router-link to="/">{{ $t("menu.accueil") }}</router-link>
      <template v-for="(item, index) in processedBreadcrumb">
        <span v-if="index != 0" :key="index">
          <span :class="$style.arrow"></span>
          <span>{{ $t(item.title) }}</span>
        </span>
      </template>
      <span v-if="processedActiveItem">
        <span :class="$style.arrow"></span>
        <strong :class="$style.current">{{ $t(processedActiveItem.title) }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenuData } from "@/services/menu";
import reduce from "lodash/reduce";
import { isKenyanSchool } from "@/utilities/countrySpecific";

export default {
  name: "breadcrumbs",
  data() {
    return {
      breadcrumb: [],
      activeItem: {},
      path: [],
    };
  },
  computed: {
    ...mapState(["settings"]),
    menuData() {
      return getMenuData;
    },
    isKenyan() {
      return isKenyanSchool();
    },
    processedBreadcrumb() {
      const isKenyan = this.isKenyan;
      return this.breadcrumb.map((item) => {
        if (item.key === "listeDesPunitions") {
          return {
            ...item,
            title: isKenyan ? "punition.studentDisciplineList" : item.title,
          };
        }
        return item;
      });
    },
    processedActiveItem() {
      if (!this.activeItem || !this.activeItem.key) {
        return this.activeItem;
      }
      if (this.activeItem.key === "listeDesPunitions") {
        return {
          ...this.activeItem,
          title: this.isKenyan ? "punition.studentDisciplineList" : this.activeItem.title,
        };
      }
      return this.activeItem;
    },
  },
  methods: {
    findPathItems(data, url, parents = []) {
      if (url === "/") {
        url = "/dashboard/alpha";
      }
      return reduce(
        data,
        (result, entry) => {
          if (result.length) {
            return result;
          }
          if (entry.children) {
            const nested = this.findPathItems(
              entry.children,
              url,
              [entry].concat(parents)
            );
            return (result || []).concat(nested.filter((e) => !!e));
          }
          if (entry.url === url) {
            return [entry].concat(parents);
          }
          return result;
        },
        []
      );
    },
    /** Sets breadcrumb + activeItem from menu URL, with fallbacks for dynamic routes. */
    syncBreadcrumb(url) {
      const items = this.findPathItems(this.menuData, url);
      if (items.length) {
        this.activeItem = items[0];
        this.breadcrumb = items;
        return;
      }
      if (url.startsWith("/decaissement/fournisseur/")) {
        const base = this.findPathItems(
          this.menuData,
          "/decaissement/fournisseurs"
        );
        if (base.length >= 2) {
          this.activeItem = {
            title: "menu.fournisseurProfile",
            key: "fournisseurProfile",
          };
          this.breadcrumb = [this.activeItem, base[1], base[0]];
          return;
        }
      }
      this.activeItem = {};
      this.breadcrumb = [];
    },
  },
  mounted: function () {
    this.syncBreadcrumb(this.$route.path);
  },
  watch: {
    $route(to) {
      this.syncBreadcrumb(to.path);
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
